// extracted by mini-css-extract-plugin
module.exports = {"Form":"Search_Form__a1iYE","Input":"Search_Input__wfx1F"};